import getContainerReducer from 'src/store/common-slices/getContainerSlice';
import uiReducer from 'src/store/common-slices/uiSlice';
import closeContainerReducer from 'src/store/common-slices/closeContainerSlice';
import batchMoveContainersReducer from 'src/store/common-slices/batchMoveContainersSlice';
import processContainerReducer from 'src/store/common-slices/processContainerSlice';
import searchContainerReducer from 'src/store/common-slices/searchSlice';
import initReducer from 'src/store/common-slices/initSlice';
import sideNavReducer from 'src/store/common-slices/sideNavSlice';
import sortContainerReducer from 'src/store/common-slices/sortContainerSlice';
import setRoutingDestinationReducer from 'src/store/common-slices/setRoutingDestinationSlice';
import cleanADirtyToteReducer from 'src/store/common-slices/cleanADirtyToteSlice';
import unloadReducer from 'src/store/common-slices/unloadSlice';

const REDUCERS = {
    GetContainer: getContainerReducer,
    UI: uiReducer,
    CloseContainer: closeContainerReducer,
    BatchMoveContainers: batchMoveContainersReducer,
    ProcessContainer: processContainerReducer,
    SearchContainer: searchContainerReducer,
    Init: initReducer,
    SideNav: sideNavReducer,
    SortContainer: sortContainerReducer,
    SetRoutingDestination: setRoutingDestinationReducer,
    CleanADirtyTote: cleanADirtyToteReducer,
    Unload: unloadReducer,
}

export default REDUCERS;